"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Banner = function (_a) {
    var title = _a.title, description = _a.description, _b = _a.withLaurel, withLaurel = _b === void 0 ? false : _b, background = _a.background;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container, style: background ? { backgroundImage: "url(".concat(background, ")") } : {} },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bannerContent },
            title && (react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                withLaurel && react_1.default.createElement("img", { src: "/img/tournaments/laurelIconLeft.svg", alt: "laurel" }),
                react_1.default.createElement("h1", null, title),
                withLaurel && react_1.default.createElement("img", { src: "/img/tournaments/laurelIconRight.svg", alt: "laurel" }))),
            description && react_1.default.createElement("h2", { className: styles_module_scss_1.default.description }, description))));
};
exports.default = Banner;
